type Tokens = { access: string; refresh: string };

const IMPERSONATION_SESSION_KEY = 'nprice-impersonation-session';
const DESKTOP_NATIVE_SESSION_KEY = 'nprice-desktop-native-session';

export const isDesktopNativeAuth = (): boolean =>
  typeof sessionStorage !== 'undefined' && sessionStorage.getItem(DESKTOP_NATIVE_SESSION_KEY) === '1';

export const getAuthStorage = (): Storage =>
  typeof sessionStorage !== 'undefined' && (sessionStorage.getItem(IMPERSONATION_SESSION_KEY) === '1' || isDesktopNativeAuth())
    ? sessionStorage
    : localStorage;

export const beginImpersonationSession = (): void => {
  sessionStorage.removeItem(DESKTOP_NATIVE_SESSION_KEY);
  sessionStorage.setItem(IMPERSONATION_SESSION_KEY, '1');
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('refreshToken');
};

export const storeImpersonationTokens = ({ access, refresh }: Tokens): void => {
  sessionStorage.removeItem(DESKTOP_NATIVE_SESSION_KEY);
  sessionStorage.setItem(IMPERSONATION_SESSION_KEY, '1');
  sessionStorage.setItem('accessToken', access);
  sessionStorage.setItem('refreshToken', refresh);
};

export const storeLoginTokens = ({ access, refresh }: Tokens): void => {
  sessionStorage.removeItem(DESKTOP_NATIVE_SESSION_KEY);
  sessionStorage.removeItem(IMPERSONATION_SESSION_KEY);
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('refreshToken');
  localStorage.setItem('accessToken', access);
  localStorage.setItem('refreshToken', refresh);
};

export const storeDesktopAccessToken = (access: string): void => {
  sessionStorage.removeItem(IMPERSONATION_SESSION_KEY);
  sessionStorage.setItem(DESKTOP_NATIVE_SESSION_KEY, '1');
  sessionStorage.setItem('accessToken', access);
  sessionStorage.removeItem('refreshToken');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
};

export const clearDesktopNativeSession = (): void => {
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('refreshToken');
  sessionStorage.removeItem(DESKTOP_NATIVE_SESSION_KEY);
};
